import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { ReceiveApiAdapter } from '../adapters/ReceiveApiAdapter';
import { CartsResponse } from '../models';

export const useCarts = (receptionId: number, enabled: boolean = true) => {
    const httpClient = createHttpClient(apiClientWH);
    const receiveAdapter = new ReceiveApiAdapter(httpClient);

    return useQuery<CartsResponse, Error>({
        queryKey: ['receptionCarts', receptionId],
        queryFn: () => receiveAdapter.getCarts(receptionId),
        enabled: receptionId > 0 && enabled,
        staleTime: 30 * 1000, // Los datos son frescos por 30 segundos
    });
};

